//import { DocumentationResourceService } from '@com.sofaxis/sofaxis-fonpel-espace-elus-ws-ts';
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DemandeSimulationResourceService } from "@com.sofaxis/sofaxis-fonpel-simulation-ws-ts/dist";

interface FileReaderEventTarget extends EventTarget {
    result: string;
}

interface FileReaderEvent extends Event {
    target: FileReaderEventTarget;
    getMessage(): string;
}

@Component( {
    selector: 'app-cg',
    templateUrl: './cgu.component.html',
    styleUrls: ['./cgu.component.scss']
} )

export class CguComponent implements OnInit {
    cgText;
    data;
    constructor( private demandeSimulationResourceService: DemandeSimulationResourceService, private dialogRef: MatDialogRef<CguComponent>, @Inject( MAT_DIALOG_DATA ) data: any ) {
        this.data = data;
    }

    ngOnInit() {
        this.demandeSimulationResourceService.downloadConditionsGenerales().subscribe(
            res => {
                const reader = new FileReader();
                reader.addEventListener( 'loadend', ( e: FileReaderEvent ) => {
                    const text = e.target.result;
                    this.cgText = text;
                } );
                reader.readAsText( res );
            } );
    }


}
